import React, { useState } from "react";
import { CameraMini, infoOutlineMini } from "../../assets/SvgIcons";
import toast from "react-hot-toast";
import axios from "axios";
import axiosInstance from "../../redux/helpers/axios";

const data = [
  {
    img: "https://wristlink.s3.me-south-1.amazonaws.com/wl-1.png",
    time: "9:35 h",
  },
  {
    img: "https://wristlink.s3.me-south-1.amazonaws.com/wl-2.png",
    time: "6:50 h",
  },
  {
    img: "https://wristlink.s3.me-south-1.amazonaws.com/wl-3.png",
    time: "9:35 h",
  },
  {
    img: "https://wristlink.s3.me-south-1.amazonaws.com/wl-4.png",
    time: "6:53 h",
  },
  {
    img: "https://wristlink.s3.me-south-1.amazonaws.com/wl-5.png",
    time: "10:12 h",
  },
  {
    img: "https://wristlink.s3.me-south-1.amazonaws.com/wl-3.png",
    time: "9:35 h",
  },
  {
    img: "https://wristlink.s3.me-south-1.amazonaws.com/wl-4.png",
    time: "6:53 h",
  },
  {
    img: "https://wristlink.s3.me-south-1.amazonaws.com/wl-5.png",
    time: "10:12 h",
  },
];

function getRandomNumber() {
  return Math.floor(Math.random() * 5);
}

const Step5 = ({ firstImg, setFirstImg, secondImg, setSecondImg }) => {
  const firstChallange = data[getRandomNumber()];
  const secondChallange = data[getRandomNumber()];

  const [firstPreview, setFirstPreview] = useState(null);
  const [secondPreview, setSecondPreview] = useState(null);
  const handleFirstImg = async (event) => {
    const file = event.target.files[0];
    const url = await handleImgUpload(file);

    setFirstImg(url);
  };

  const handleSecondImg = async (event) => {
    const file = event.target.files[0];
    const url = await handleImgUpload(file);

    setSecondImg(url);
  };

  const generateLinkFromString = (str) => {
    return str?.split("")?.length > 0
      ? `${Math.floor(1000000000 + Math.random() * 9000000000)}-${str
          ?.toLowerCase()
          ?.replace(/\s+/g, "-")}`
      : ""; // Replace spaces (or multiple spaces) with hyphens
  };

  const handleImgUpload = async (file) => {
    const id = toast.loading("Loading...");
    try {
      const response = await axiosInstance.get(`/utils/aws/get-presigned-url`, {
        params: {
          filename: generateLinkFromString(file.name),
          fileType: file.type,
        },
      });

      const { url, objectUrl } = response.data;
      await axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
      });
      toast.dismiss(id);
      return objectUrl;
    } catch (error) {
      console.log(error);

      toast.error("Image upload failed!", { id: id });
    }
  };
  return (
    <section className="">
      <h1 className="lg:text-4xl md:text-3xl sm:text-xl">Proof of Ownership</h1>
      <p className="text-[14px] mt-4 mb-8">
        Please set the watch to the following times and upload a photo of each.
        This is our way of confirming that you are in possession of the watch.
        These photos will also be published in your listing.
      </p>

      <div className="grid grid-cols-2 gap-4 mt-8">
        <div className="w-full border border-secondary rounded border-dashed flex justify-between gap-4 p-4">
          <div className="w-1/2 flex flex-col justify-center items-center">
            {" "}
            <img
              src={firstChallange.img}
              width={120}
              height={120}
              alt=""
              className=""
            />
            <p className="mt-4 text-[14px] ">{firstChallange.time}</p>
          </div>

          <div className="w-1/2">
            <input
              onChange={handleFirstImg}
              type="file"
              id="first"
              className="hidden"
              multiple={false}
            />

            <label
              htmlFor="first"
              className=" h-full w-full border border-secondarylight  border-dashed text-secondary rounded-lg   flex  justify-center items-center gap-6 cursor-pointer"
            >
              {firstImg === null ? (
                <div className="  text-gray-500 flex flex-col justify-center items-center">
                  {CameraMini}
                  <p className="text-[16px] font-medium  mt-2 ">
                    Upload photos
                  </p>
                </div>
              ) : (
                <img src={firstImg} alt="" className="" />
              )}
            </label>
          </div>
        </div>
        <div className="w-full border border-secondary rounded border-dashed flex justify-between gap-4 p-4">
          <div className="w-1/2 flex flex-col justify-center items-center">
            {" "}
            <img
              src={secondChallange.img}
              width={120}
              height={120}
              alt=""
              className=""
            />
            <p className="mt-4 text-[14px] ">{secondChallange.time}</p>
          </div>

          <div className="w-1/2">
            <input
              onChange={handleSecondImg}
              type="file"
              id="second"
              className="hidden"
              multiple={false}
            />

            <label
              htmlFor="second"
              className=" h-full w-full border border-secondarylight  border-dashed text-secondary rounded-lg   flex  justify-center items-center gap-6 cursor-pointer"
            >
              {secondImg === null ? (
                <div className="  text-gray-500 flex flex-col justify-center items-center">
                  {CameraMini}
                  <p className="text-[16px] font-medium  mt-2 ">
                    Upload photos
                  </p>
                </div>
              ) : (
                <img src={secondImg} alt="" className="" />
              )}
            </label>
          </div>
        </div>
      </div>

      <div className="w-full h-full text-[14px] bg-primarylight p-4 rounded-lg mt-6">
        <p className="font-medium mb-3">Instructions</p>
        <p className="">
          Use diffused natural light or a softbox to eliminate harsh shadows and
          highlight product details. Ensure a clean, uncluttered background
          (like white or neutral colors) for focus on the product.
        </p>
      </div>
    </section>
  );
};

export default Step5;
